module.exports = __webpack_public_path__ + "img/logo.0fd90c4e.png";